export const categories = [
  {
    slug: 'anquan-xuzhi',
    name: '安全须知',
    description: '了解不同自慰方式的安全注意事项，避免身体损伤，确保每一次自我探索都在安全范围内进行。',
    icon: 'ri-shield-check-line',
    color: 'bg-amber-100 text-amber-700',
  },
  {
    slug: 'weisheng-yaodian',
    name: '卫生要点',
    description: '掌握自慰前后的卫生清洁知识，预防感染，维护生殖系统健康。',
    icon: 'ri-drop-line',
    color: 'bg-emerald-100 text-emerald-700',
  },
  {
    slug: 'jiankang-zhidao',
    name: '健康指导',
    description: '科学认识自慰与身体健康的关系，建立适度、健康的自我愉悦习惯。',
    icon: 'ri-heart-pulse-line',
    color: 'bg-rose-100 text-rose-700',
  },
  {
    slug: 'xinli-jiankang',
    name: '心理健康',
    description: '探讨自慰与情绪、自尊、性心理的关系，帮助建立积极健康的性自我认同。',
    icon: 'ri-mental-health-line',
    color: 'bg-violet-100 text-violet-700',
  },
  {
    slug: 'changjian-wuqu',
    name: '常见误区',
    description: '澄清关于自慰的常见误解与谣言，用科学事实替代错误认知。',
    icon: 'ri-question-answer-line',
    color: 'bg-orange-100 text-orange-700',
  },
  {
    slug: 'changjian-wenti',
    name: '常见问题',
    description: '收集并回答与自慰方式相关的常见疑问，提供专业、易懂的解答。',
    icon: 'ri-question-line',
    color: 'bg-cyan-100 text-cyan-700',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => { categoryMap[cat.slug] = cat; });